import React from 'react';
import { BrowserRouter } from 'react-router-dom';

export const RoutingProvider = ({ children }: any) => {
  return <BrowserRouter>{children}</BrowserRouter>;
};
